'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ShowIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 24C28 26.2091 26.2091 28 24 28C21.7909 28 20 26.2091 20 24C20 21.7909 21.7909 20 24 20C26.2091 20 28 21.7909 28 24ZM27 24C27 25.6569 25.6569 27 24 27C22.3431 27 21 25.6569 21 24C21 22.3431 22.3431 21 24 21C25.6569 21 27 22.3431 27 24Z" }),
    React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 24C34 24 31.5 31 24 31C16.5 31 14 24 14 24C14 24 16.5 17 24 17C31.5 17 34 24 34 24ZM33 24C33 24 30.5 30 24 30C17.5 30 15 24 15 24C15 24 17.5 18 24 18C30.5 18 33 24 33 24Z" }))); };

exports.default = ShowIcon;
//# sourceMappingURL=index.js.map
